import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import { FaSeedling, FaCarrot, FaHandshake, FaLeaf } from 'react-icons/fa';
import './About.css';

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="about-page">
      <PageMeta
        title={t('about.title')}
        description={t('about.subtitle')}
        path="/about"
      />
      <Header />
      
      <section className="about-hero">
        <div className="about-hero-container">
          <h1 className="about-hero-title">{t('about.title')}</h1>
          <p className="about-hero-subtitle">
            {t('about.subtitle')}
          </p>
        </div>
      </section>

      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            <h2 className="about-section-title">{t('about.missionTitle')}</h2>
            <p className="about-section-text">
              {t('about.missionP1')}
            </p>
            <p className="about-section-text">
              {t('about.missionP2')}
            </p>
          </div>
        </div>
      </section>

      <section className="about-section about-values-section">
        <div className="about-container">
          <h2 className="about-section-title about-text-center">{t('about.valuesTitle')}</h2>
          <div className="about-values-grid">
            <div className="about-value-card">
              <div className="about-value-icon" aria-hidden>
                <FaSeedling />
              </div>
              <h3 className="about-value-title">{t('about.value1Title')}</h3>
              <p className="about-value-text">
                {t('about.value1Desc')}
              </p>
            </div>
            <div className="about-value-card">
              <div className="about-value-icon" aria-hidden>
                <FaCarrot />
              </div>
              <h3 className="about-value-title">{t('about.value2Title')}</h3>
              <p className="about-value-text">
                {t('about.value2Desc')}
              </p>
            </div>
            <div className="about-value-card">
              <div className="about-value-icon" aria-hidden>
                <FaHandshake />
              </div>
              <h3 className="about-value-title">{t('about.value3Title')}</h3>
              <p className="about-value-text">
                {t('about.value3Desc')}
              </p>
            </div>
            <div className="about-value-card">
              <div className="about-value-icon" aria-hidden>
                <FaLeaf />
              </div>
              <h3 className="about-value-title">{t('about.value4Title')}</h3>
              <p className="about-value-text">
                {t('about.value4Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="about-container">
          <h2 className="about-section-title about-text-center">{t('about.storyTitle')}</h2>
          <p className="about-section-text">
            {t('about.storyP1')}
          </p>
          <p className="about-section-text">
            {t('about.storyP2')}
          </p>
          <p className="about-section-text">
            {t('about.storyP3')}
          </p>
          <p className="about-section-text">
            <Link to="/guides" className="about-guides-link">{t('about.readGuides')}</Link>
          </p>
        </div>
      </section>

      <section className="about-section about-coverage-section">
        <div className="about-container">
          <h2 className="about-section-title about-text-center">{t('about.coverageTitle')}</h2>
          <p className="about-section-text about-text-center about-max-width">
            {t('about.coverageDesc')}
          </p>
          <div className="about-districts-grid">
            <div className="about-district-card">
              <h3 className="about-district-name">{t('about.morang')}</h3>
              <p className="about-district-info">
                {t('about.morangDesc')}
              </p>
            </div>
            <div className="about-district-card">
              <h3 className="about-district-name">{t('about.sunsari')}</h3>
              <p className="about-district-info">
                {t('about.sunsariDesc')}
              </p>
            </div>
            <div className="about-district-card">
              <h3 className="about-district-name">{t('about.jhapa')}</h3>
              <p className="about-district-info">
                {t('about.jhapaDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta-section">
        <div className="about-container">
          <h2 className="about-cta-title">{t('about.ctaTitle')}</h2>
          <p className="about-cta-text">
            {t('about.ctaDesc')}
          </p>
          <div className="about-cta-buttons">
            <Link to="/signup?type=farmer" className="about-btn-cta-primary">
              {t('landing.becomeAFarmer')}
            </Link>
            <Link to="/signup" className="about-btn-cta-secondary">
              {t('landing.startShopping')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
